"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = function (msg) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    console.log(msg, params);
};
exports.error = function (msg) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    console.error(msg, params);
};
exports.warn = function (msg) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    console.warn(msg, params);
};
exports.debug = function (msg) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    console.debug(msg, params);
};
exports.default = {
    log: exports.log,
    error: exports.error,
    debug: exports.debug,
    warn: exports.warn,
};
